import { render, staticRenderFns } from "./EditorDialog.vue?vue&type=template&id=203fd0ba"
import script from "./EditorDialog.vue?vue&type=script&lang=js"
export * from "./EditorDialog.vue?vue&type=script&lang=js"
import style0 from "./EditorDialog.vue?vue&type=style&index=0&id=203fd0ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports